import { createSelector } from "@reduxjs/toolkit";

import { selectCartCount } from "@/src/features/cart/cartApi";
import { selectWishlistCount } from "@/src/features/wishlist/wishlistApi";

export const selectHeaderBadges = createSelector(
  [selectCartCount, selectWishlistCount],
  (cartCount, wishlistCount) => ({
    cartCount,
    wishlistCount,
  }),
);
